import React from 'react';

import { ContactDetails } from '@components/utilities/Contact/ContactDetails';

export const ConsigneeDetails: React.FC = () => <ContactDetails type="consignee" />;
